// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Spinner/Spinner.less
// module id = 232
// module chunks = 2